export const entrance = {
	title: "Entradas",
	addEntrance: "Adicionar entrada",
	deleteEntrance: "Deseja deletar a entrada {{entranceName}}?",
	table: {
		entrance: "Entrada",
		category: "Categoria",
		value: "Valor",
		consumptionObligation: "Consumação mínima",
		minimumConsumptionValue: "Consumação antecipada",
		active: "Ativo",
		variable: "Variável",
		bonus: "Bônus",
		sku: "SKU",
	},
	entranceForm: {
		addEntrance: "Adicionar Entrada",
		editEntrance: "Editar entrada",
		bonus: "Bônus",
		details: "Informações da entrada",
		name: "Nome",
		namePlaceHolder: "Digite o nome da entrada",
		category: "Categoria",
		categoryPlaceholder: "Selecione a categoria da entrada",
		price: "Preço",
		variablePrice: "Preço variável",
		consumptionObligation: "Consumação mínima",
		minimumValueCharged: "Valor mínimo cobrado",
		minimumValueChargedTooltip:
			"A Valor mínimo cobrado é o menor valor que o cliente irá pagar na conta e é a soma da consumação mínima com o preço da entrada",
		minimumConsumptionValue: "Consumação antecipada",
		image: "Foto",
		fiscalData: "Dados fiscais",
		code: "SKU",
		codePlaceholder: "Digite a SKU referente a entrada",
		ncm: "NCM",
		ncmPlaceholder: "Digite o NCM dessa entrada",
		cest: "CEST",
		cestPlaceholder: "Digite o CEST da entrada",
		fiscalProfile: "Perfil fiscal",
		fiscalProfilePlaceholder: "Selecione o perfil fiscal da entrada",
		fiscalGroup: "Grupo fiscal",
		fiscalGroupPlaceholder: "Selecione o grupo fiscal da entrada",
		newCategory: "Você criará uma nova categoria",
	},
	errors: {
		mandatoryField: "Esse campo é obrigatório",
		validValue: "Digite um valor válido",
		consumption: "Não é possivel cadastrar mais de um tipo de consumação",
	},
	edit: "Editar",
	add: "Adicionar",
	cancel: "Cancelar",
};
